export default "__VITE_ASSET__BDc$B2r7__"